import styled from 'styled-components';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';


export const Nav = styled.nav`
  &.NavWrapper{
    display: flex;
    justify-content: flex-end;
    padding: 31px 44px;
  }
  &.NavWrapperResults{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px 0 45px;
    background: linear-gradient( rgba(149,190,249,0.8),rgba(149,190,249,0.02));
    @media screen and (min-width: 1200px) {
      padding: 35px 45px 55px 45px;
    }
  }
  &.NavWrapperNotSigned{
    display: flex;
    margin: 20px 0;
    width: 100%;
    //padding: 0 15px;
  }
  &.NavWrapperSigned{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 42px 6rem 34px;
    padding-top: 30px;
  }
  & .drop-item {
    &:hover{
      text-decoration: underline;
      background: initial;
    }
  }
`;

export const StyledBtn = styled(Button)`
  &.SignInBtn{
    width: 124px;
    height: 48px;
    line-height: 36px;
    background-color: #80ABED;
    box-sizing: border-box;
    border-radius: 8px ;
    display: flex ;
    justify-content: center;
    align-items: center;
    border: none;
  }
  &.SimpleLinks{
    font-family: OpenSans, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px ;
    line-height: 180% ;
    color: #4F5388 ;
  }
  &.SearchBtn{
    border: 2px solid #4F5388;
    border-radius: 4px;
    padding-left: 24px;
    padding-right: 24px;
    &:hover{
      text-decoration: none;
    }
  }
  &:focus{
    box-shadow: none;
  }
  &:not(:last-child){
    margin-right: 20px;
  }
  &.SignInBtn:hover{
    filter: drop-shadow(-8.49px -8.49px 5px rgba(255, 255, 255, 0.33)), drop-shadow(8.17px 8.17px 12px rgba(36, 38, 89, 0.1));
    border: none;
  }
  &.SignInBtn:focus{
    box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
    border: none;
  }
  &.SignInBtn:not(:disabled):not(.disabled):active{
    border: none;
    box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
    background-color: #80ABED;
    border-width: 0;
  }
`;

export const StyledLink = styled(Link)`
  font-family: Manrope, sans-serif;
  font-style: normal;
  font-weight: 900;
  text-align: center;
  color: #4F5388;
  line-height: 50px;
  white-space: nowrap;
  &.NotSignedHeader{
    font-size: 42px;
  }
  &.SignedHeader{
    font-size: 24px;
  }
  &:hover{
    color: #4F5388;
    text-decoration: none;
  }
`;

export const Container = styled.div`
  &.RightNotSignedBlock{
    display: flex;
    align-items: center;
  }
  &.RightResultsBlock{
    display: flex;
    align-items: center;
    margin-left: auto;
  }
  &.NavLogoContainer{
    margin-left: auto;
    margin-right: 35px;
  }
  &.RightSignedBlock{
    display: flex;
    align-items: center;
    margin-left: auto;
  }
  &.WrapperNotSigned{
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    width: 100%;
  }
`;

export const DropToggle = styled.div`
  cursor: pointer;
`

export const NavLink = styled(Link)`
  font-family: OpenSans, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px ;
  line-height: 180% ;
  color: #4F5388 ;
  padding: .375rem .75rem;
  &:hover{
    color: #4F5388;
    text-decoration: none;
  }
  &:not(:last-child){
    margin-right: 20px;
  }
  &.outlined{
    border: 2px solid #4F5388;
    border-radius: 4px;
    padding-left: 24px;
    padding-right: 24px;
    &:hover{
      text-decoration: none;
    }
  }
`
